var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Echarts",staticStyle:{"padding-top":"10px"}},[_c('div',{ref:"Statistical",staticClass:"echarts-container",style:({ width: '100%', height: _vm.chartHeight + 'px' })})])}
var staticRenderFns = []

export { render, staticRenderFns }